namespace GeniuzPOS.Purchase {
    export interface PoPurOrderAppForm {
        AppList: PoApprovalEditor;
        SysDocNo: Serenity.StringEditor;
        PurDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        SupplierId: Serenity.LookupEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        ShipId: Serenity.LookupEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        ShipName: Serenity.StringEditor;
        ShipLineAddress1: Serenity.StringEditor;
        ShipLineAddress2: Serenity.StringEditor;
        ShipLineAddress3: Serenity.StringEditor;
        PayTermCode: Serenity.LookupEditor;
        VatFg: Serenity.RadioButtonEditor;
        POTypeFg: Serenity.RadioButtonEditor;
        SalesVatTypes: Serenity.LookupEditor;
        DtList: PoPurOrderDtAppEditor;
        Remark: Serenity.StringEditor;
        TotalAmt: Serenity.DecimalEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        NetExVat: Serenity.DecimalEditor;
        VatCode: Serenity.LookupEditor;
        VatRate: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        PurOrderAmt: Serenity.DecimalEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        ApproveFg: Serenity.IntegerEditor;
        SendForAppfg: Serenity.IntegerEditor;
        CancelFg: Serenity.EnumEditor;
    }

    export class PoPurOrderAppForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPurOrderApp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPurOrderAppForm.init)  {
                PoPurOrderAppForm.init = true;

                var s = Serenity;
                var w0 = PoApprovalEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = PoPurOrderDtAppEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.IntegerEditor;
                var w8 = s.EnumEditor;

                Q.initFormType(PoPurOrderAppForm, [
                    'AppList', w0,
                    'SysDocNo', w1,
                    'PurDocNo', w1,
                    'DocNo', w1,
                    'DocDate', w2,
                    'SupplierId', w3,
                    'RefDocNo1', w1,
                    'RefDocNo2', w1,
                    'ShipId', w3,
                    'ShipDate', w2,
                    'WhsId', w1,
                    'ShipName', w1,
                    'ShipLineAddress1', w1,
                    'ShipLineAddress2', w1,
                    'ShipLineAddress3', w1,
                    'PayTermCode', w3,
                    'VatFg', w4,
                    'POTypeFg', w4,
                    'SalesVatTypes', w3,
                    'DtList', w5,
                    'Remark', w1,
                    'TotalAmt', w6,
                    'DiscText', w1,
                    'DiscAmt', w6,
                    'NetAmt', w6,
                    'NetExVat', w6,
                    'VatCode', w3,
                    'VatRate', w6,
                    'VatAmt', w6,
                    'PurOrderAmt', w6,
                    'NetTotalInVat', w6,
                    'ApproveFg', w7,
                    'SendForAppfg', w7,
                    'CancelFg', w8
                ]);
            }
        }
    }
}
